var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 7h16m-1 0-.867 12.142c-.0359.5046-.2617.9768-.6319 1.3216-.3702.3447-.8572.5364-1.3631.5364h-8.276c-.50586 0-.99293-.1917-1.36311-.5364-.37019-.3448-.59597-.817-.63189-1.3216l-.867-12.142zm-9 4v6zm4 0v6zm1-4v-3c0-.26522-.1054-.51957-.2929-.70711-.1875-.18753-.4419-.29289-.7071-.29289h-4c-.26522 0-.51957.10536-.70711.29289-.18753.18754-.29289.44189-.29289.70711v3z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2ce4a56d94e1e8260eb93c4e854b744b.svg";
export { ForwardRef as ReactComponent };